import { ChainId } from '@pancakeswap/sdk'
import { getFullDecimalMultiplier } from '@pancakeswap/utils/getFullDecimalMultiplier'

export const IS_QA = process.env.NEXT_PUBLIC_ENV === 'qa'
export const IS_PROD = process.env.NEXT_PUBLIC_ENV === 'main'

export const BSC_BLOCK_TIME = 3

// CAKE_PER_BLOCK details
// 40 CAKE is minted per block
// 20 CAKE per block is sent to Burn pool (A farm just for burning cake)
// 10 CAKE per block goes to CAKE syrup pool
// 9 CAKE per block goes to Yield farms and lottery
// CAKE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// CAKE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const CAKE_PER_BLOCK = 40
export const BLOCKS_PER_DAY = (60 / BSC_BLOCK_TIME) * 60 * 24
export const BLOCKS_PER_YEAR = BLOCKS_PER_DAY * 365 // 10512000
export const CAKE_PER_YEAR = CAKE_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://magmaswap.finance'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const DEFAULT_TOKEN_DECIMAL = getFullDecimalMultiplier(18)
export const DEFAULT_GAS_LIMIT = 250000n
export const BOOSTED_FARM_GAS_LIMIT = 500000n
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'

export const GRAPH_NODE_EXCHANGE_V3_MIN_BLOCK = IS_PROD ? 76491107 : 4302966

export const GRAPH_NODE_EXCHANGE_V3_MIN_BLOCKS = {
  [ChainId.MANTLE]: 76491107 ,
  [ChainId.MANTLE_TESTNET]: 4302966,
}

export const GRAPH_NODE_MIN_BLOCK = (block: number | string): any => {
  if (!block) {
    return block
  }

  const node = window?.location?.search?.includes('chain=mantleTestnet')
    ? GRAPH_NODE_EXCHANGE_V3_MIN_BLOCKS[ChainId.MANTLE_TESTNET]
    : GRAPH_NODE_EXCHANGE_V3_MIN_BLOCKS[ChainId.MANTLE]

  return parseInt(Number(block).toString(), 10) >= GRAPH_NODE_EXCHANGE_V3_MIN_BLOCK ? block : node
}
